module.exports = __webpack_public_path__ + "img/more.25cc6c1b.svg";